import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import { useIsomorphicLayoutEffect } from "~/client/hooks";
import { PORTAL_ROOT_SELECTOR } from "./constants";
export const usePortal = () => {
  const $ = _c(2);
  const ref = useRef(null);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const portalRoot = document.querySelector(PORTAL_ROOT_SELECTOR);
      ref.current = portalRoot;
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useIsomorphicLayoutEffect(t0, t1);
  return ref;
};